module.exports = __webpack_public_path__ + "static/assets/917012df58a9a7fa5740ac527793fe74.png";